import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { persistReducer } from 'redux-persist';
import { splitReducer } from '@splitsoftware/splitio-redux';
import storage from 'redux-persist/lib/storage';

import organizationReducer from 'modules/Organization/redux/reducers/organizationReducer';
import allBillerReducer from 'modules/AllBillers/redux/reducers/allBillerReducer';
import deliveryReducer from 'modules/Delivery/redux/reducers/deliveryReducer';
import goldReducer from 'modules/Gold/redux/reducers/goldReducer';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import interactionReducer from './interactionReducer';
import newFilterReducer from './newFilterReducer';

const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['auth0user', 'auth0loading', 'getAllTokenLoading'],
};

export default combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  errors: errorReducer,
  form: formReducer,
  interaction: interactionReducer,
  gold: goldReducer,
  organization: organizationReducer,
  allbiller: allBillerReducer,
  newFilter: newFilterReducer,
  delivery: deliveryReducer,

  splitio: splitReducer,
});
